import { Amplify } from "aws-amplify";
import { generateClient } from 'aws-amplify/api';
import { createUserAnswer } from '../graphql/mutations'; // Adjust the path if necessary

Amplify.configure({
  API: {
    GraphQL: {
      endpoint: 'https://xv2dyatqpvaf3jufy7f46ecvou.appsync-api.eu-west-2.amazonaws.com/graphql',
      region: 'eu-west-2',
      defaultAuthMode: 'apiKey',
      apiKey: 'da2-bvbmxvtgqbhhneitzmh3iydxpu'
    }
  }
});
// Generate a new API client instance
const client = generateClient();

/**
 * saveMedicalQuizAnswers
 *
 * Saves the quiz responses for the current user.
 *
 * @param {string} userId - The unique identifier for the user (from Cognito).
 * @param {any} answers - The quiz responses to be saved (can be an array or object).
 * @returns {Promise} - Resolves with the result of the GraphQL mutation.
 */
export async function saveMedicalQuizAnswers(userId, answers) {
  try {
    if (!userId) {
      throw new Error('userId is required');
    }

    // Ensure answers is an array
    const answersArray = Array.isArray(answers) ? answers : [];
    
    // Convert answers to strings and remove nulls/undefined
    const formattedAnswers = answersArray
      .filter(answer => answer != null)
      .map(answer => answer.toString());

    const response = await client.graphql({
      query: createUserAnswer,
      variables: {
        input: {
          userId,
          answers: formattedAnswers,
          timestamp: new Date().toISOString()
        }
      }
    });
    
    if (!response.data?.createUserAnswer) {
      throw new Error('Failed to save quiz answers - no data returned');
    }
    
    return response.data.createUserAnswer;
  } catch (error) {
    console.error('GraphQL error:', error);
    if (error.message === 'userId is required') {
      throw error;
    }
    throw new Error(`Failed to save quiz answers: ${error.message}`);
  }
}
